import React, { Component } from 'react';
import { Redirect, Switch, Link, BrowserRouter, Route } from 'react-router-dom'
import Auth from './Auth';
import history from '../history';
import axios from 'axios';
import Autocomplete from 'react-autocomplete';

export default class Stat extends React.Component {
    
    constructor(props) {
        super(props);

        this.inputFio = this.inputFio.bind(this);
        this.submit = this.submit.bind(this);
        this.getPosition = this.getPosition.bind(this);


        this.state = { 
            fio: '',
            listFioIsLoaded: false,
            listFio: [],
            paid1: 0,
            paid2: 0,
            paid3: 0
        };
    };
    
    inputFio(e){
        this.setState({
            fio: e.target.value
        })
    }
    
    submit(){
        
    }
    
    getPosition(){
        
    }
    
    componentWillMount(){
    //получение списка ФИО
       axios
          .get("/server/getListFio.php")
          .then((result) => {   
            
            let list = result.data;
            list.pop();
            //console.log(list);
            
            this.setState({
                listFioIsLoaded: true,
                listFio: list
            });
          });
    }
    
    render() {
        if( this.props.role == 'stat' ){
            return (
            <div className='stat'>
                
                <div className='fio-block'>
                ФИО ППС
                <Autocomplete
                    items={this.state.listFio}
                    shouldItemRender={(item, value) => item.toLowerCase().indexOf(value.toLowerCase()) > -1}
                    getItemValue={item => item}
                    renderItem={(item, highlighted) =>
                      <div
                        key={item.id}
                        style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}
                      >
                        {item}
                      </div>
                    }
                    value={this.state.fio}
                    onChange={e => this.setState({ fio: e.target.value })}
                    onSelect={value => this.setState({ fio: value })}
                />
                </div>
                
                <div className='paid-1-block'>
                    <input
                        onChange={e => this.setState({ paid1: e.target.value })}
                        value={this.state.paid1}
                        type='number'
                    />    
                </div>

                <div className='paid-2-block'>
                    <input
                        onChange={e => this.setState({ paid2: e.target.value })}
                        value={this.state.paid2}
                        type='number'
                    />    
                </div>

                <div className='paid-3-block'>
                    <input
                        onChange={e => this.setState({ paid3: e.target.value })}
                        value={this.state.paid3}
                        type='number'
                    />    
                </div>

                <div className='submit-button' onClick={this.submit}>Отправить</div>

            </div>
            );   
        } else {
            history.push('/auth');
            return ('');
        }
    }
}


// WEBPACK FOOTER //
// ./src/component/Stat.js